import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ModalContainer = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 95vw;
  width: ${(props) => (props.isMobile ? "90%" : "600px")};
  background-color: #ffffff;
  padding: 24px;
  outline: none;
`;

export const ModalTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: ${Colors.SPM800};
  text-align: center;
  margin-bottom: 8px;
`;

export const ModalSubtitle = styled.p`
  font-family: "Sora", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: ${Colors.SPM600};
  text-align: center;
  margin-bottom: 24px;
`;

export const AppointmentList = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 24px;
  text-align: left;
`;

export const AppointmentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

export const PatientName = styled.span`
  font-family: "Sora", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${Colors.SPM800};
`;

export const AppointmentDateTime = styled.div`
  display: flex;
  gap: 16px;
`;

export const AppointmentDate = styled.span`
  font-family: "Sora", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: ${Colors.SPM600};
`;

export const AppointmentTime = styled.span`
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${Colors.SPM800};
`;

export const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;
